/** 
 * Do not show sidebar if empty.
 * BE still render the sidebar if there are no items in it. It also displays an empty avatar that shouldn't be there
**/
const sidebar = document.querySelector('.detail-side');

if(sidebar) {
    const sidebarTitle = sidebar.querySelector('.h4'),
        sidebarAvatar = sidebar.querySelector('.detail-side__avatar');

    if(sidebarAvatar && !sidebarTitle){
        sidebar.classList.add('hide');
    }
}